var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.161,
    height: 23.518,
    viewBox: "0 0 22.161 23.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zip",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M36.8,6.365,30.812.139A.453.453,0,0,0,30.486,0h-8.93a1.814,1.814,0,0,0-1.812,1.812V8.141H16.125A1.357,1.357,0,0,0,14.769,9.5v6.787a1.357,1.357,0,0,0,1.356,1.356h3.619V21.71a1.813,1.813,0,0,0,1.812,1.809H35.117a1.812,1.812,0,0,0,1.812-1.808V6.678A.453.453,0,0,0,36.8,6.365ZM30.6,1.221l4.918,5.111H30.6ZM16.125,16.734a.452.452,0,0,1-.451-.451V9.5a.452.452,0,0,1,.451-.451H28.338a.452.452,0,0,1,.451.451v6.787a.452.452,0,0,1-.451.451Zm19.9,4.977a.907.907,0,0,1-.908.9H21.556a.907.907,0,0,1-.908-.9V17.639h7.689a1.357,1.357,0,0,0,1.356-1.356V9.5a1.357,1.357,0,0,0-1.356-1.356H20.648V1.812A.909.909,0,0,1,21.556.9h8.137v5.88a.452.452,0,0,0,.452.452h5.879Z",
    transform: "translate(-14.769)",
    fill: "#0065a4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.14cce540.svg";
export { ForwardRef as ReactComponent };